import * as z from "zod";

export const getFulfillmentServicesThatFulfillForTeam = {
  name: "getFulfillmentServicesThatFulfillForTeam" as const,
  input: z.object({}),
  output: z.object({
    fulfillmentServices: z.array(
      z.object({ _id: z.string(), name: z.string() }),
    ),
  }),
};
